import { styled } from "styled-components";

export const StyledSubtitle = styled.p`
  line-height: 1.25;
  margin-top: 0;
  color: ${({ theme }) => theme.colors.textBright};
`;
